module.exports = __webpack_public_path__ + "static/media/guoshaoyun.64a2ae31.png";